import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import UtilFunctions from '~utils/functions';
import { CustomerAccFundTypeEnum, CustomerIdTypeEnum, EarmarkReleaseRequestStatusEnum, GoldTypeEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';
import combinedActions from '~redux/combinedActions';
import { TUpdateEarmarkConversionStatusReduxParams, TUpdateReleaseEarmarkStatusReduxParams } from '~types/feat/approval';
import Table from '~components/molecules/Table';
import ActionButton from '~components/atoms/ActionButton';
import * as Styles from './_earmarkApprovalTable.module.scss';
import { useEffect } from 'react';
const EarmarkApprovalTable = () => {
    const dispatch = useAppDispatch();

    const {
        Misc:
        {
            dateTimeFormat,
            renderPendingReleaseEarmarkStatusChip,
        },
    } = UtilFunctions;

    const pendingReleaseEarmarkListing = useAppSelector(state => state.approval.pendingReleaseEarmarkListing.data);
    const getPendingReleaseEarmarkListingIsLoading = useAppSelector(state => state.approval.loadings.getPendingReleaseEarmarkListing);

    const earmarkConversionListing = useAppSelector(state => state.gold.earmarkConversionListing.data);
    const getEarmarkConversionListingLoading = useAppSelector(state => state.gold.loadings.getEarmarkConversionListing);

    const access = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Approval);

    const setTempUpdateEarmarkConversionState = (data: TUpdateEarmarkConversionStatusReduxParams) => dispatch(combinedActions.approvalSetTempUpdateEarmarkConversionState(data));
    const setConfirmUpdateStatusModalIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateEarmarkConversionStatusModalIsOpen(open));

    const handleApproveClick = (id: number) => {
        setTempUpdateEarmarkConversionState({ id, status: 2 });
        setConfirmUpdateStatusModalIsOpen(true);
    };

    const handleRejectClick = (id: number) => {
        setTempUpdateEarmarkConversionState({ id, status: 3 });
        setConfirmUpdateStatusModalIsOpen(true);
    };

    const tableHeader = [
        'TRANSACTION ID',
        'PROJECT NAME',
        'CUSTOMER NAME',
        'ID NUMBER',
        'CIF NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'BRANCH TELLER NAME',
        'EARMARK END DATE',
        'ACTION',
    ];

    useEffect(() => {
        dispatch(combinedActions.goldGetEarmarkConversionListingAttempt({
            index: 0,
        }));

    }, []);

    const renderActionButton = (id: number, status: number) => {
        if (status === 1) {
            return (
                <div className={Styles['action-button-container']}>
                    {hasEditAccess && (
                        <ActionButton
                            label='Approve'
                            onClick={() => handleApproveClick(id)}
                            className={`${Styles['action-button']} ${Styles.approve}`}
                        />
                    )}
                    {hasEditAccess && (
                        <ActionButton
                            label='Reject'
                            onClick={() => handleRejectClick(id)}
                            className={`${Styles['action-button']} ${Styles.reject}`}
                        />
                    )}
                </div>
            );
        }
        return '-';
    };

    const tableBody = earmarkConversionListing.map((item) => {
        const {
            id,
            transactionId,
            projectName,
            customerName,
            CIFNo,
            branchCode,
            branchName,
            regionName,
            branchTellerName,
            earmarkEndDate,
            idNo,
            fundType,
            status,
        } = item;

        return [
            transactionId,
            projectName,
            customerName,
            idNo,
            CIFNo,
            branchCode,
            branchName,
            regionName,
            branchTellerName,
            dateTimeFormat(earmarkEndDate),
            renderActionButton(id, status),
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableBody}
            isLoading={getEarmarkConversionListingLoading}
        />
    );
};

export default EarmarkApprovalTable;
